import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormDecidable } from "@/shared/ui";

export interface StepFields {
	hadNavCollection: boolean;
	hasRescheduledPublicDebt: boolean;
}

export class Step4 extends AbstractStep<StepFields> {
	protected renderContent(values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						label="Volt inkasszó a vállalkozás számláján az elmúlt 36 hónapban?"
						name="hadNavCollection"
						required
					/>
					{values.hadNavCollection === true && (
						<div className="info-1 bg-warning text-white p-2 w-100">
							Az inkasszók gyakorisága a hiteldöntést negatívan befolyásolthatja, így szakértőnkkel
							további egyeztetés szükséges.
						</div>
					)}
					<FormDecidable
						label="Van a cégednek átütemezett köztartozása? (pl. NAV részletfizetés)"
						name="hasRescheduledPublicDebt"
						required
					/>
					{values.hasRescheduledPublicDebt === true && (
						<div className="info-2 bg-warning text-white p-2 w-100">
							A NAV átütemezett köztartozás megléte kizáró tényező lehet, szakértőnkkel további egyeztetés
							szükséges.
						</div>
					)}
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step4";
	}
}
